import {ProductForm} from '@shopify/theme-product-form';

const selectors = {
  formElement: '[data-product-form]',
  productJson: '[data-product-json]',
  productOptionsJson: '[data-product-options-json]',
};

function initQuickAddForm(quickAddDrawer) {
  class productQuickAdd extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector(selectors.formElement);

      this.initProductForm();
    }

    initProductForm() {
      if (!this.form) return;

      const productData = this.querySelector(selectors.productJson)?.innerHTML ?? '{}';
      const productJSON = JSON.parse(productData);

      const productOptionsData = this.querySelector(selectors.productOptionsJson)?.innerHTML ?? '{}';
      const productOptionsJSON = JSON.parse(productOptionsData);
      productJSON.options = productOptionsJSON;

      // Register the product form using @shopify/theme-product-form
      const formElement = this.form;
      const options = {
        onOptionChange: () => true,
        onFormSubmit: this.onFormSubmit.bind(this),
        onQuantityChange: () => true,
        onPropertyChange: () => true,
      };
      this.productForm = new ProductForm(formElement, productJSON, options);
    }

    onFormSubmit(event) {
      event.preventDefault();

      const variant = event.dataset.variant;
      const variantId = variant.id;
      const quantity = event.dataset.quantity;

      const closeDrawerOnSuccess = () => {
        quickAddDrawer.classList.add('is-hidden');
        quickAddDrawer.classList.remove('is-visible');
        quickAddDrawer.setAttribute('aria-hidden', true);
        document.body.classList.remove('quickadd-is-visible');
      };

      window.sideCart.handleAddToCartEvent(
        event,
        variantId,
        quantity,
        true,
        null,
        null,
        null,
        null,
        closeDrawerOnSuccess
      );
    }
  }

  customElements.define('product-quickadd', productQuickAdd);
}

export default initQuickAddForm;
